var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var GruaTecnicsFilter = /** @class */ (function (_super) {
    __extends(GruaTecnicsFilter, _super);
    function GruaTecnicsFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.codi = null;
        _this.nom = '';
        _this.DNI = '';
        _this.labels['codi'] = _this.i18n('Codi');
        _this.labels['nom'] = _this.i18n('Nom');
        _this.labels['DNI'] = _this.i18n('DNI');
        return _this;
    }
    return GruaTecnicsFilter;
}(FilterData));
export { GruaTecnicsFilter };
